<template>
    <u-tit-wrap-default v-bind="$attrs">
        <u-tit-subtit v-if="this.$slots['TitAdd']" class="tit--xs"><slot name="TitAdd" /></u-tit-subtit>
        <u-tit-default class="tit--lg"><slot /></u-tit-default>
        <u-txt-default v-if="this.$slots['TxtAdd']" class="txt--sm"><slot name="TxtAdd" /></u-txt-default>
    </u-tit-wrap-default>
</template>

<script>
import UTitWrapDefault from "@/components/publish/styles/typography/u-tit-wrap-default.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import UTitSubtit from "@/components/publish/styles/typography/u-tit-subtit.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";

export default {
    props: {},
    components: {
        UTitWrapDefault,
        UTitDefault,
        UTitSubtit,
        UTxtDefault,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
